/**
 * LocalStorage helper for dwell time persistence
 * Works across web/msite platforms
 */
var LocalStorageHelper = /** @class */ (function () {
    function LocalStorageHelper() {
    }
    /**
     * Get value from localStorage
     * @param key Storage key
     * @returns Promise resolving to stored value or null
     * Note: Returns Promise for backward compatibility, but localStorage.getItem is synchronous
     */
    LocalStorageHelper.getValue = function (key) {
        return Promise.resolve(this.getValueSync(key));
    };
    /**
     * Get value from localStorage synchronously
     * @param key Storage key
     * @returns Stored value or null
     */
    LocalStorageHelper.getValueSync = function (key) {
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                return window.localStorage.getItem(key);
            }
        }
        catch (e) {
            console.error('Error reading from localStorage:', e);
        }
        return null;
    };
    /**
     * Set value in localStorage
     * @param key Storage key
     * @param value Value to store
     */
    LocalStorageHelper.setValue = function (key, value) {
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem(key, value);
            }
        }
        catch (e) {
            console.error('Error writing to localStorage:', e);
        }
    };
    /**
     * Remove value from localStorage
     * @param key Storage key
     */
    LocalStorageHelper.removeValue = function (key) {
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.removeItem(key);
            }
        }
        catch (e) {
            console.error('Error removing from localStorage:', e);
        }
    };
    return LocalStorageHelper;
}());
export default LocalStorageHelper;
